import React, { useState } from 'react';
import FinalQuotationApprovalButtons from '../components/FinalQuotationApprovalButtons';
import FinalQuotationApprovalModal from '../modals/FinalQuotationApprovalModal';

const FinalQuotationApprovalScreen = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRole, setSelectedRole] = useState('');

  const handleRoleSelect = (role) => {
    setSelectedRole(role);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleConfirmRole = () => {
    // Handle the actual confirmation logic here
    console.log(`Confirmed final quotation approval role: ${selectedRole}`);
    setIsModalOpen(false);
  };

  return (
    <div className="w-full bg-white rounded-lg shadow-sm border border-gray-100 p-6">
      <div className="mb-6">
        <h2 className="text-2xl font-semibold text-gray-800 text-center">Select Final Quotation Approval Role</h2>
        <p className="text-gray-500 text-center mt-2">Choose a role to proceed with the final quotation approval.</p>
      </div>

      <FinalQuotationApprovalButtons onRoleSelect={handleRoleSelect} />

      <FinalQuotationApprovalModal 
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onConfirm={handleConfirmRole}
        role={selectedRole}
      />
    </div>
  );
};

export default FinalQuotationApprovalScreen;
